import { render, staticRenderFns } from "./Create_field_form.vue?vue&type=template&id=07490bfb&scoped=true"
import script from "./Create_field_form.vue?vue&type=script&lang=js"
export * from "./Create_field_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07490bfb",
  null
  
)

export default component.exports